import { getMonth, getYear, addMonths, subMonths, startOfMonth, lastDayOfMonth, addDays } from 'date-fns';


export const months = [
  { label: 'January', value: 'january', monthIndex: 0 },
  { label: 'February', value: 'february', monthIndex: 1 },
  { label: 'March', value: 'march', monthIndex: 2 },
  { label: 'April', value: 'april', monthIndex: 3 },
  { label: 'May', value: 'may', monthIndex: 4 },
  { label: 'June', value: 'june', monthIndex: 5 },
  { label: 'July', value: 'july', monthIndex: 6 },
  { label: 'August', value: 'august', monthIndex: 7 },
  { label: 'September', value: 'september', monthIndex: 8 },
  { label: 'October', value: 'october', monthIndex: 9 },
  { label: 'November', value: 'november', monthIndex: 10 },
  { label: 'December', value: 'december', monthIndex: 11 },
];

export const generateMonthsOptions = () => {
  // get the current month
  const thisMonth = getMonth(new Date());
  const thisYear = getYear(new Date());
  const lastYear = thisYear - 1;

  const monthsDeepSlice = JSON.parse(JSON.stringify(months));

  // get the months trailing last year
  const trailingMonths = monthsDeepSlice.slice(thisMonth).map(m => {
    m.label = `${m.label} ${lastYear}`;
    m.year = lastYear;
    return m;
  });

  // get the months leading this year
  const leadingMonths = monthsDeepSlice.slice(0, thisMonth).map(m => {
    m.label = `${m.label} ${thisYear}`;
    m.year = thisYear;
    return m;
  });

  const options = trailingMonths.concat(leadingMonths).reverse();
  return options;
};

export const getInitialReportMonth = () => {
  return monthsOptions[0];
};

export const monthsOptions = generateMonthsOptions();